export interface EdgeVoice {
  name: string
  locale: string
  gender: 'Male' | 'Female'
  label: string
}

export const EDGE_VOICES: readonly EdgeVoice[] = [
  { name: 'bs-BA-VesnaNeural', locale: 'bs-BA', gender: 'Female', label: 'Vesna (ženski)' },
  { name: 'bs-BA-GoranNeural', locale: 'bs-BA', gender: 'Male', label: 'Goran (muški)' },
]

export const DEFAULT_EDGE_VOICE = 'bs-BA-VesnaNeural'

export function isEdgeVoice(name: string | null): boolean {
  if (!name) return false
  return EDGE_VOICES.some((v) => v.name === name)
}
